$(document).ready(function(){
    var autoPlay = $('.block__hero-content-main').data('autoplay');
    var autoPlaySpeed = $('.block__hero-content-main').data('autoplayspeed');
$('.block__hero-content .block__hero-content-main').not('.slick-initialized').slick({
    slidesToShow:1,
    slidesToScroll:1,
    pauseOnHover: false,
    adaptiveHeight: true,
    infinite:false,    
  	arrows: false,
    draggable: false,
    dots:true,
    autoplay: autoPlay,
    autoplaySpeed: autoPlaySpeed,
    // customPaging : function(slider, i) {
    // var thumb = $(slider.$slides[i]).data();
    //   return (i + 1);
    // }
  }); 
}); 